import { FC } from 'react';
import { Translate } from 'shared/components/translate/translate';
import localizationConstants from 'shared/util/translation/constant';
import { SOCCER_ID } from 'features/createContest/constants/createContest';

const OddsRulesAndScoring: FC<{ contestSportId: string }> = ({ contestSportId }) => {
	const isSoccer = contestSportId === SOCCER_ID;
	return (
		<div className='odd-rules-wrapper'>
			{/* Title: Risk Reward mode */}
			<p className='rules-scoring-title'>
				<Translate text={localizationConstants.riskRewardMode} />
			</p>
			<div>
				<p className='rules-scoring-detail'>
					<Translate text={localizationConstants.inRiskReward} />{' '}
					<span className='font--bold'>
						<Translate
							text={
								isSoccer
									? localizationConstants.boostHomeWinDrawAwayWin
									: localizationConstants.boostHomeWinAwayWin
							}
						/>{' '}
					</span>
					<Translate text={localizationConstants.and} />{' '}
					<span className='font--bold'>
						<Translate text={localizationConstants.safety} />
					</span>
					. <Translate text={localizationConstants.pointsRule} />
				</p>

				<p className='rules-scoring-detail'>
					<Translate text={localizationConstants.strategicAdjust} />
				</p>
				<p className='rules-scoring-detail'>
					<Translate text={localizationConstants.picksChangeInfo} />
				</p>
				<p className='rules-scoring-detail'>
					<Translate text={localizationConstants.savePicksReminder} />
				</p>
			</div>

			{/* Rules: Boost and Safety */}
			<p className='rules-scoring-title font--bold'>
				<Translate text={localizationConstants.rulesForBoostAndSafety} />
			</p>
			<ul className='rules-list list-style-disc ml--30 mt--0 mb--5'>
				<li className='mb--5'>
					<p className='rules-list-detail'>
						<span className='font--bold'>
							<Translate text={localizationConstants.boost} />{' '}
						</span>
						<Translate text={localizationConstants.boostRule} />
					</p>
					<p className='rules-list-detail'>
						<Translate
							text={
								isSoccer
									? localizationConstants.footBallBoostRule
									: localizationConstants.basketBallBoostRule
							}
						/>
					</p>
				</li>
				<li>
					<p className='rules-list-detail'>
						<span className='font--bold'>
							<Translate text={localizationConstants.safety} />{' '}
						</span>
						<Translate text={localizationConstants.safetyRule} />
					</p>
					<p className='rules-list-detail'>
						<Translate
							text={
								isSoccer
									? localizationConstants.footBallSafetyRule
									: localizationConstants.basketBallSafetyRule
							}
						/>
					</p>
				</li>
			</ul>
			<p className='rules-scoring-detail'>
				<Translate text={localizationConstants.planBets} />
			</p>

			<>
				<p className='text--primary font--semi-bold'>
					<Translate text={localizationConstants.tieRules} />:
				</p>
				<p className='rules-scoring-detail'>
					<Translate text={localizationConstants.tieRulesDescription} />
				</p>
			</>

			<>
				<p className='text--primary font--semi-bold'>
					<Translate text={localizationConstants.note} />:
				</p>
				<p className='rules-scoring-detail'>
					<Translate text={localizationConstants.pointsPublication} />
				</p>
			</>
		</div>
	);
};

export default OddsRulesAndScoring;
